// extracted by mini-css-extract-plugin
export default {"watchscreen":"Watch_watchscreen__IPN7-","back_btn":"Watch_back_btn__SVzP9"};